module.exports = __webpack_public_path__ + "img/img7.e9cb8dd9.svg";